<div class="language" (click)="toggleList()" data-ctx="button-language-toggle">
  <img [src]="'/assets/svg/flags/' + getCurrentLanguage() + '.svg'" />
  <span class="label">{{ getCurrentLanguage() }}</span>
</div>
@if (isOpen) {
  <ul [@show]>
    @for (language of languages; track language) {
      <div
        class="language"
        (click)="changeLanguage(language)"
        >
        <img [src]="'/assets/svg/flags/' + language + '.svg'" />
        <span class="label">{{ language }}</span>
      </div>
    }
  </ul>
}
